module.exports = __webpack_public_path__ + "media/img/frontend_application/stats/icon-park_ranking-7370b2d2ac0ee9c2a3304771d69b47bc.png";